module.exports = __webpack_public_path__ + "img/logo.fc09a863.png";